export let activeClick = true
export let setActiveClick = (data) =>activeClick = data
export let groupRef = null
export let setGroupRef = (refData) => groupRef=refData
export let sentTime = null
export let setSentTime = (time)=>sentTime=time
export let receivedTime = null
export let setReceivedTime = (time)=>receivedTime=time